import React from 'react';
import { style } from 'typestyle';
import { type MdiReactIconComponentType } from 'mdi-react/dist/typings';
import * as styles from './navigation-item.styles';
import mergeClasses from '../../utils/merge-classes';

export type NavigationIcon = MdiReactIconComponentType;

interface Props {
  readonly title: string;
  readonly icon?: NavigationIcon;
  readonly isActive?: boolean;
  readonly isCollapsed?: boolean;
  readonly className?: string;
  readonly onClick?: () => void;
}

const NavigationItem = ({ title, icon: Icon, isActive, isCollapsed, className, onClick }: Props): React.JSX.Element => (
  <div
    className={mergeClasses(className, style(styles.navigationItem(isActive, isCollapsed)))}
    onClick={onClick}
    role="presentation"
    title={isCollapsed === true ? title : undefined}
  >
    {isActive === true && <span className={style(styles.activeIndicator)} />}
    {Icon != null && <Icon size={19} className={style(styles.icon)} />}
    {isCollapsed !== true && <div className={style(styles.title)}>{title}</div>}
  </div>
);

export default NavigationItem;
